module.exports = __webpack_public_path__ + "static/media/progressive_app_m9ms.478a567d.svg";